module.exports = __webpack_public_path__ + "img/emsbanner2.f16db15d.png";